
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
@Component
export default class Group extends Vue {
  @Prop({ required: true }) readonly dataSource!: any[];


  getDate(item: any) {
    return moment(item.createDate).format('DD.MM.YYYY HH:mm');
  }

  getInstanceState(item: any) {
    switch (item.instanceStateId) {
      case 1:
        return 'Создан';
      case 4:
        return 'Активен'
      default:
        return "Создан"
    }
  }
  getInstanceColor(item: any) {
    switch (item.instanceStateId) {
      case 1:
        return 'warning';
      case 4:
        return 'primary';
      default:
        return 'default';
    }
  }
}
